// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visitante-form-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f9f9f9;
  padding: 20px;
}

.visitante-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.visitante-logo img {
  max-width: 200px;
  object-fit: contain;
  max-height: 80px;
  mix-blend-mode: multiply;
}

.visitante-alert-warning {
  margin-top: 12px;
  padding: 12px 16px;
  background-color: #fff3cd;
  border: 1px solid #ffe69c;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  color: #664d03;
  font-size: 14px;
  text-align: center;
  max-width: 600px;
}

/* Tabs de etapas */
.visitante-steps {
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 1000px;
  margin-bottom: 10px;
}

.visitante-steps span {
  font-size: 14px;
  padding: 10px;
  font-weight: bold;
  color: var(--fundo2);
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

.visitante-active {
  color: var(--azul) !important;
  border-bottom: 2px solid var(--azul) !important;
}

.visitante-form {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 1000px;
}

.visitante-step {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.visitante-step h2 {
  font-size: 18px;
  margin-bottom: 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f9f9f9;
  color: var(--azul);

}

.visitante-step label {
  font-size: 12px;
  color: var(--azul);

}

.visitante-step select,
.visitante-step input[type="text"],
.visitante-step input[type="date"],
.visitante-step input[type="email"],
.visitante-step input[type="tel"],
.visitante-step input[type="file"] {
  padding: 8px;
  font-size: 14px;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 20px;
  box-sizing: border-box;
}

.visitante-step input:focus {
  border-color: var(--azul);
  outline: none;
}

/* Estilo dos botões */
.visitante-buttons {
  display: flex;
  justify-content: space-between !important;
  width: 100%;
  margin-top: 10px;
}


.visitante-buttons button:disabled {
  background-color: #ccc;
  opacity: 0;
  cursor: default;
}

.visitante-step p {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}

.visitante-step input[type="checkbox"] {
  margin-right: 10px;
}

.visitante-error {
  color: var(--Vermelho);
  font-size: 11px;
  margin-bottom: 10px;
}

.oab-lookup-hint {
  width: 100%;
  font-size: 13px;
  font-weight: 600;
  color: var(--texto);
  margin: -4px 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.oab-lookup-hint-loading {
  color: var(--texto-destaque);
  font-weight: 700;
}

.oab-lookup-spinner {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  display: inline-block;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: oab-lookup-spin .7s linear infinite;
}

@keyframes oab-lookup-spin {
  to {
    transform: rotate(360deg);
  }
}

.oab-lookup-box {
  width: 100%;
  background-color: var(--fundo2);
  border: 1px solid var(--texto-destaque);
  border-radius: 8px;
  padding: 10px 14px;
  margin: -4px 0 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.oab-lookup-box strong {
  color: var(--texto-destaque);
  font-size: 13px;
}

.oab-lookup-box span {
  font-size: 12px;
  color: var(--texto);
}

.oab-lookup-box p {
  margin: 4px 0 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--texto-destaque);
}

.oab-lookup-box.oab-status-regular {
  background-color: var(--verde2);
  border-color: var(--verde);
}

.oab-lookup-box.oab-status-regular strong,
.oab-lookup-box.oab-status-regular p {
  color: var(--verde);
}

.oab-lookup-box.oab-status-cancelado {
  background-color: var(--vermelho2);
  border-color: var(--Vermelho);
}

.oab-lookup-box.oab-status-cancelado strong,
.oab-lookup-box.oab-status-cancelado p {
  color: var(--Vermelho);
}

.oab-lookup-box.oab-status-falecido {
  background-color: var(--fundo2);
  border-color: var(--azul);
}

.oab-lookup-box.oab-status-falecido strong,
.oab-lookup-box.oab-status-falecido p {
  color: var(--azul);
}

.oab-lookup-box.oab-status-outro {
  background-color: var(--amarelo3);
  border-color: var(--amarelo2);
}

.oab-lookup-box.oab-status-outro strong,
.oab-lookup-box.oab-status-outro p {
  color: var(--amarelo2);
}


.add-interno-btn {

  max-width: 200px;
  padding: 6px;
  margin-bottom: 20px;
}

.visitante-btn-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.visitante-btn-spinner {
  width: 14px;
  height: 14px;
  display: inline-block;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  opacity: .85;
  animation: visitante-btn-spin .7s linear infinite;
}

@keyframes visitante-btn-spin {
  to {
    transform: rotate(360deg);
  }
}

.del-interno-btn {
  padding: 0;
  background: none;
  color: var(--Vermelho);
  text-align: center;
  font-size: 22px;
}

.internal-result {
  position: relative;
}

.internal-result .internal-suggestions {
    position: absolute;
    left: 0;
    top: 50px;
    max-height: 300px;
    padding: 8px 0;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 1px 1px 3px 0;
    overflow: auto;
    cursor: pointer;
  }

:is(.internal-result .internal-suggestions)  > div {
      padding: 5px 8px;
      border-bottom: 1px solid #f9f9f9;
    }

.internal-result .internal-suggestions>div:hover {
  background-color: #f9f9f9;
}

/* Seção de documentos */
.documents-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

/* Campos de input de arquivos para ficarem mais elegantes */
.visitante-step input[type="file"] {
  padding: 0;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 20px;
  cursor: pointer;
}

/* Estilo especial para inputs de arquivo para visualmente indicá-los */
.visitante-step input[type="file"]::file-selector-button {
  background-color: var(--azul);
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 16px;
  cursor: pointer;
  opacity: .8;
}

.visitante-step input[type="file"]:hover::file-selector-button {
  opacity: 1;
}

.visitante-cadastro-v2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  background: var(--fundo);
}

.visitante-cadastro-v2 .visitante-logo {
  align-self: center;
  text-align: center;
}

.visitante-cadastro-v2 .visitante-form-card {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  background: var(--branco);
  border-radius: 24px;
  padding: 32px 36px;
  border: 1px solid var(--borda);
  box-shadow: 0 25px 65px rgba(3, 78, 162, 0.08);
}

.visitante-cadastro-v2 .visitante-mode-switch {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  gap: 10px;
}

.visitante-cadastro-v2 .visitante-mode-btn {
  border: 1px solid var(--borda);
  background: var(--branco);
  color: var(--texto2);
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 600;
  cursor: pointer;
}

.visitante-cadastro-v2 .visitante-mode-btn.active {
  border-color: var(--azul);
  color: var(--azul);
  background: rgba(3, 78, 162, 0.08);
}

.visitante-cadastro-v2 .visitante-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  background-color: var(--fundo-input);
  padding: 14px;
  border-radius: 18px;
}

.visitante-cadastro-v2 .visitante-steps-item span {
  padding: 0;
  color: inherit;
}

.visitante-cadastro-v2 .visitante-steps-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  color: var(--texto2);
  border: 1px solid transparent;
  transition: all 0.3s ease;
  min-height: 74px;
}

.visitante-cadastro-v2 .visitante-steps-index {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: var(--texto-destaque);
  background: var(--branco);
  border: 1px solid var(--borda);
}

.visitante-cadastro-v2 .visitante-steps-item.visitante-active {
  background: var(--branco);
  color: var(--azul);
  border-color: var(--azul);
  box-shadow: 0 4px 12px rgba(3, 78, 162, 0.1);
  border-bottom: none;
}

.visitante-cadastro-v2 .visitante-steps-item.visitante-active .visitante-steps-index {
  border-color: var(--azul);
}

.visitante-cadastro-v2 .visitante-steps-item.visitante-complete {
  background: rgba(0, 121, 50, 0.1);
  color: var(--verde);
  border-color: var(--verde);
}

.visitante-cadastro-v2 .visitante-steps-item.visitante-complete .visitante-steps-index {
  background: var(--verde);
  border-color: transparent;
  color: var(--branco);
}

.visitante-cadastro-v2 .visitante-steps-label {
  line-height: 1.2;
  flex: 1 1;
  font-size: 10px;
  color: inherit;
  text-align: left;
  word-break: break-word;
}

.visitante-cadastro-v2 .visitante-steps-item.visitante-active .visitante-steps-label {
  color: var(--azul2);
}

.visitante-cadastro-v2 .visitante-steps-item.visitante-complete .visitante-steps-label {
  color: var(--verde);
}

.visitante-cadastro-v2 .visitante-form-modern {
  margin-top: 28px;
  padding: 0;
  background: transparent;
  box-shadow: none;
  width: 100%;
}

.visitante-cadastro-v2 .visitante-step {
  background: var(--branco);
  border: 1px solid var(--borda);
  border-radius: 18px;
  padding: 24px;
  margin-bottom: 18px;
  box-shadow: 0 12px 30px rgba(17, 16, 29, 0.05);
}

.visitante-cadastro-v2 .visitante-step h2 {
  color: var(--texto-destaque);
  font-size: 20px;
  margin-bottom: 18px;
  padding-bottom: 8px;
  border-bottom: 1px solid transparent;
  position: relative;
}

.visitante-cadastro-v2 .visitante-step h2::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 50px;
  height: 3px;
  border-radius: 2px;
  background: var(--amarelo);
}

.visitante-cadastro-v2 .visitante-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.visitante-cadastro-v2 .visitante-form .form-group-duplo {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
}

.visitante-cadastro-v2 .visitante-step select,
.visitante-cadastro-v2 .visitante-step input[type="text"],
.visitante-cadastro-v2 .visitante-step input[type="date"],
.visitante-cadastro-v2 .visitante-step input[type="email"],
.visitante-cadastro-v2 .visitante-step input[type="tel"],
.visitante-cadastro-v2 .visitante-step input[type="file"] {
  padding: 12px;
  font-size: 14px;
  border-radius: 12px;
  border: 1px solid var(--borda);
  background: var(--fundo-input);
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.visitante-cadastro-v2 .visitante-step input:focus,
.visitante-cadastro-v2 .visitante-step select:focus {
  border-color: var(--azul);
  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.15);
  background: var(--branco);
}

.visitante-cadastro-v2 .add-interno-btn {
  background: var(--azul);
  color: var(--branco);
  border: none;
  border-radius: 12px;
  padding: 10px 18px;
  font-weight: 600;
}

.visitante-cadastro-v2 .internal-result .internal-suggestions {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  width: 100%;
  max-height: 220px;
  background: var(--branco);
  border: 1px solid var(--borda);
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);
  overflow: auto;
  z-index: 2;
}

.visitante-cadastro-v2 .internal-result .internal-suggestions>div {
  padding: 10px 14px;
  border-bottom: 1px solid var(--fundo-input);
  color: var(--texto);
}

.visitante-cadastro-v2 .internal-result .internal-suggestions>div:last-child {
  border-bottom: none;
}

.visitante-cadastro-v2 .internal-result .internal-suggestions>div:hover {
  background: var(--fundo-input);
}

.visitante-cadastro-v2 .visitante-internal-table,
.visitante-cadastro-v2 .visitante-summary-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  border: 1px solid var(--borda);
  border-radius: 16px;
  overflow: hidden;
}

.visitante-cadastro-v2 .visitante-internal-table th,
.visitante-cadastro-v2 .visitante-summary-table th {
  background: var(--amarelo3);
  color: var(--texto-destaque);
  text-transform: uppercase;
  font-size: 12px;
}

.visitante-cadastro-v2 .visitante-internal-table td,
.visitante-cadastro-v2 .visitante-summary-table td {
  background: var(--branco);
  font-size: 14px;
  border-bottom: 1px solid var(--fundo-input);
}

.visitante-cadastro-v2 .visitante-summary-table tr:last-child td,
.visitante-cadastro-v2 .visitante-internal-table tr:last-child td {
  border-bottom: none;
}

.visitante-cadastro-v2 .visitante-summary-table td:first-child {
  color: var(--texto2);
  font-weight: 600;
  width: 35%;
}

.visitante-cadastro-v2 .documents-section {
  gap: 16px;
}

.visitante-cadastro-v2 .documents-section .form-group {
  background: var(--fundo-input);
  padding: 16px;
  border-radius: 14px;
  border: 1px dashed var(--borda);
}

.visitante-cadastro-v2 .visitante-buttons {
  padding-top: 6px;
  justify-content: flex-end !important;
  gap: 12px;
}

.visitante-cadastro-v2 .visitante-buttons button {
  min-width: 150px;
  height: 44px;
  border-radius: 14px;
  font-weight: 600;
}

.visitante-cadastro-v2 .visitante-btn-secondary {
  border: 1px solid var(--borda);
  color: var(--texto-destaque);
  background: transparent;
}

.visitante-cadastro-v2 .visitante-btn-secondary:hover {
  border-color: var(--azul);
  color: var(--azul);
}

.visitante-cadastro-v2 .visitante-btn-primary {
  background: linear-gradient(90deg, var(--azul), var(--azul2));
  color: var(--branco);
  border: none;
}

.visitante-cadastro-v2 .visitante-buttons button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 992px) {
  .visitante-cadastro-v2 .visitante-form-card {
    padding: 24px;
  }

  .visitante-cadastro-v2 .visitante-mode-switch {
    flex-wrap: wrap;
  }
}

@media (max-width: 600px) {
  .visitante-cadastro-v2 .visitante-steps {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }

  .visitante-cadastro-v2 .visitante-step {
    padding: 18px;
  }

  .visitante-cadastro-v2 .visitante-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .visitante-cadastro-v2 .visitante-buttons button {
    width: 100%;
  }

  .visitante-cadastro-v2 .visitante-mode-btn {
    width: 100%;
  }
}

.visitor-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 4px 12px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
}

.visitor-status.status-verde {
  color: #00B087;
  background-color: #CFFAEA;
}

.visitor-status.status-amarelo {
  color: #b58900;
  background-color: #FDF3D5;
}

.visitor-status.status-vermelho {
  color: #FFFFFF;
  background-color: #E24343;
}

.visitor-status.status-laranja {
  color: #7A1D0C;
  background-color: #FFD9D1;
}

.actions-container {
  position: relative;
  display: inline-block;
}

.btn-actions {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: var(--azul-escuro);
}

.actions-menu {
  position: absolute;
  top: 25px;
  right: 0;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  min-width: 140px;
  z-index: 10;
}

.actions-menu .action-item {
  padding: 10px;
  border: none;
  background: none;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  color: var(--azul-escuro);
  cursor: pointer;
  border-bottom: 1px solid var(--borda);
}

.actions-menu .action-item:last-child {
  border-bottom: none;
}

.actions-menu .action-item:hover {
  background-color: #f1f1f1;
}

.visitor-details-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.visitor-details-card {
  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
  border: 1px solid #e4e9f6;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 24px rgba(17, 24, 39, 0.06);
  margin-bottom: 20px;
  transition: box-shadow .2s ease, border-color .2s ease;
}

.visitor-details-card:hover {
  box-shadow: 0 14px 30px rgba(17, 24, 39, 0.09);
  border-color: #d8e1f7;
}

.visitor-details-card>header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
}

.visitor-details-card>header h3 {
  margin: 0;
  color: var(--azul-escuro);
}

.visitor-details-card>header span {
  margin: 0;
  color: var(--texto2);
  font-size: .8rem;
}

.visitor-details-card>header p {
  margin: 4px 0 0;
  color: var(--texto);
  font-size: 0.9rem;
}

.visitor-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 16px;
  color: var(--azul-escuro);
  font-size: 1.15rem;
}

.visitor-details-card>header .visitor-card-title {
  margin: 0;
}

.visitor-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(3, 78, 162, 0.1);
  color: var(--azul);
  font-size: 0.85rem;
  flex-shrink: 0;
}

.visitor-hero-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.visitor-hero-meta h3 {
  margin: 0;
  font-size: 1.4rem;
  color: var(--azul-escuro);
}

.visitor-hero-wrapper {
  display: flex;
  align-items: center;
  gap: 14px;
}

.visitor-hero-photo {
  width: 92px;
  height: 114px;
  border-radius: 12px;
  border: 1px solid #d5def2;
  overflow: hidden;
  background: #f4f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.08);
}

.visitor-hero-photo--clickable {
  cursor: pointer;
  transition: opacity 0.15s, border-color 0.15s;
}

.visitor-hero-photo--clickable:hover {
  opacity: 0.82;
  border-color: var(--azul, #3b6fd4);
}

.visitor-hero-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.visitor-hero-photo span {
  font-size: 11px;
  color: #697392;
  text-align: center;
  padding: 8px;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 1.2;
}

.visitor-hero-photo-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #b0bad4;
  padding: 8px;
}

.visitor-hero-photo-empty svg {
  transition: color 0.2s;
}

.visitor-hero-photo--clickable:hover .visitor-hero-photo-empty svg {
  color: var(--azul, #3b6fd4);
}

.visitor-hero-photo-empty small {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #b0bad4;
  line-height: 1.2;
  text-align: center;
}

.visitor-hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.visitor-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.visitor-info-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.visitor-info-tile {
  background: #f7f9ff;
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  padding: 12px 14px;
  min-height: 72px;
  justify-content: center;
  transition: border-color .15s ease, background .15s ease;
}

.visitor-info-tile:hover {
  border-color: #c7d5f6;
  background: #f1f5ff;
}

.visitor-info-row span {
  font-size: 0.75rem;
  font-weight: bold;
  color: var(--texto-destaque);
  text-transform: uppercase;
}

.visitor-info-row p {
  margin: 0;
  color: var(--texto);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.visitor-access-tag {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  border: 1px solid transparent;
}

.visitor-access-tag.enabled {
  color: #0a7a55;
  background: #dff8ee;
  border-color: #b6edd9;
}

.visitor-access-tag.disabled {
  color: #7a3b00;
  background: #fff1de;
  border-color: #f3d2a6;
}

.visitor-access-tag.denied {
  color: #8f1d1d;
  background: #ffe1e1;
  border-color: #f4b6b6;
}

.visitor-access-tag.pending {
  color: #7a5b00;
  background: #fff7d8;
  border-color: #efd98a;
}

.visitor-details-relations {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.visitor-details-relations > div {
  background: #f7f9ff;
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  padding: 14px;
}

.visitor-details-relations strong {
  display: block;
  margin-bottom: 6px;
  font-size: 0.9rem;
  color: var(--azul-escuro);
}

.visitor-details-relations ul {
  list-style: disc;
  padding-left: 20px;
  margin: 0;
  color: var(--texto-destaque);
}

.visitor-details-relations li {
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.visitor-internal-link {
  color: var(--azul);
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.visitor-internal-link:hover {
  color: var(--azul2);
  text-decoration: underline;
}

.visitor-docs-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 12px;
}

.visitor-docs-item {
  background: #f7f9ff;
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.visitor-docs-item--image {
  background: #edf3ff;
  border-color: #cad7f4;
}

.visitor-docs-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.visitor-docs-meta strong {
  color: var(--azul-escuro);
  font-size: 0.95rem;
}

.visitor-docs-meta span {
  color: var(--texto);
  font-size: 0.85rem;
}

.visitor-docs-empty {
  color: var(--texto);
  margin: 0;
}

.visitor-action-buttons,
.visitor-section-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}



.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.visitor-doc-upload-form .form-group {
  flex-basis: 100%;
}

.relationship-results {
  margin-top: 20px;
}

.relationship-types-section {
  margin-top: 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--borda);
}

.relationship-types-section h4 {
  margin-bottom: 10px;
  color: var(--texto-destaque);
}

.relationship-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px 12px;
}

.relationship-type-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--texto);
}

.relationship-type-option input[type='checkbox'] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.relationship-results h4 {
  margin-bottom: 10px;
  color: var(--texto-destaque);
}

.relationship-results table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}

.relationship-results table th,
.relationship-results table td {
  border: 1px solid var(--borda);
  padding: 8px;
  text-align: left;
}

.relationship-empty {
  margin: 10px 0;
  color: var(--texto);
}

.relationship-pending-card {
  margin: 12px 0;
  padding: 14px 16px;
  border: 2px solid var(--Azul, #3b82f6);
  border-radius: 8px;
  background: var(--fundo-card, #f0f6ff);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.relationship-pending-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.relationship-pending-info strong {
  font-size: 14px;
  color: var(--texto-destaque);
}

.relationship-pending-info span {
  font-size: 12px;
  color: var(--texto);
}

.relationship-pending-form {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.relationship-pending-select {
  flex: 1 1;
  min-width: 160px;
  padding: 6px 10px;
  border: 1px solid var(--borda);
  border-radius: 6px;
  font-size: 13px;
  background: var(--fundo);
  color: var(--texto);
}

.relationship-pending-actions {
  display: flex;
  gap: 8px;
}

.relationship-type-select {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid var(--borda);
  border-radius: 4px;
  font-size: 13px;
  background: var(--fundo);
  color: var(--texto);
}

.auth-modal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.auth-column {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.auth-column h4 {
  margin: 0;
  color: var(--texto-destaque);
}

.auth-status-info {
  background-color: #eef3ff;
  border-radius: 6px;
  padding: 8px;
  font-size: 0.85rem;
  color: var(--texto);
}

.auth-status-tag {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #f1f1f5;
  color: var(--texto);
}

.auth-status-tag.success {
  background-color: rgba(46, 125, 50, 0.15);
  color: #2e7d32;
  font-size: 11px;
}

.auth-status-tag.danger {
  background-color: rgba(211, 47, 47, 0.15);
  color: #d32f2f;
  font-size: 11px;
}

.auth-status-tag.pending {
  background-color: rgba(255, 193, 7, 0.2);
  color: #b28704;
}

.auth-textarea-group textarea {
  max-width: 100%;
  min-width: 100%;
  min-height: 90px;
}

.visitor-authorization-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
}

.authorization-column h4 {
  margin: 0 0 10px;
  color: var(--texto-destaque);
  font-size: 1rem;
}

.authorization-column {
  background: #f7f9ff;
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  padding: 14px;
}

.visitor-auth-history {
  margin-top: 18px;
  border-top: 1px solid #e2e8fb;
  padding-top: 14px;
}

.visitor-auth-history h4 {
  margin: 0 0 10px;
  color: var(--texto-destaque);
  font-size: 0.95rem;
}

.visitor-auth-history-list {
  display: grid;
  gap: 10px;
}

.visitor-auth-history-item {
  background: #f7f9ff;
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.visitor-auth-history-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.visitor-auth-history-head strong {
  color: var(--azul-escuro);
  font-size: 0.92rem;
}

.visitor-auth-history-head span {
  color: #657390;
  font-size: 0.8rem;
  white-space: nowrap;
}

.visitor-auth-history-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.visitor-auth-history-grid small {
  display: block;
  color: #64748b;
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 2px;
}

.visitor-auth-history-grid p {
  margin: 0;
  color: var(--texto);
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-break: break-word;
  width: 100%;
}

.visitor-switch-group {
  background: #f7f9ff;
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  padding: 12px;
}

.visitor-switch-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}

.visitor-switch-label {
  font-size: 12px;
  font-weight: 700;
  color: #7a88a8;
  min-width: 28px;
  text-align: center;
}

.visitor-switch-label.active {
  color: #1f3fa5;
}

.visitor-switch {
  position: relative;
  width: 46px;
  height: 24px;
  display: inline-block;
}

.visitor-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.visitor-switch-slider {
  position: absolute;
  inset: 0;
  background: #cfd8ee;
  border-radius: 999px;
  cursor: pointer;
  transition: .2s ease;
}

.visitor-switch-slider::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #fff;
  transition: .2s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
}

.visitor-switch input:checked + .visitor-switch-slider {
  background: #2d57cf;
}

.visitor-switch input:checked + .visitor-switch-slider::before {
  transform: translateX(22px);
}

.visitor-autocomplete {
  position: relative;
}

.visitor-autocomplete-list {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  max-height: 220px;
  overflow-y: auto;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #dfe6f5;
  border-radius: 12px;
  box-shadow: 0 14px 24px rgba(17, 24, 39, 0.1);
  z-index: 20;
}

.visitor-autocomplete-list li {
  padding: 10px 12px;
  cursor: pointer;
  color: var(--texto);
  font-size: 14px;
}

.visitor-autocomplete-list li:hover {
  background: #f5f8ff;
}

@media (max-width: 768px) {
  .visitor-details-card > header {
    flex-direction: column;
  }

  .visitor-hero-wrapper {
    width: 100%;
    align-items: flex-start;
  }

  .visitor-hero-photo {
    width: 72px;
    height: 94px;
  }

  .visitor-section-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

/* ── Modal de foto do visitante ─────────────────────────────── */
.photo-modal-header {
  margin-bottom: 20px;
}

.photo-modal-label {
  font-size: 15px;
  font-weight: 700;
  color: #1e2a45;
  letter-spacing: 0.01em;
}

.photo-modal-hint {
  font-size: 11px;
  color: #9aa3bc;
  margin: 2px 0 0;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.photo-upload-zone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 220px;
  border-radius: 14px;
  border: 2px dashed #cdd6ed;
  background: #f6f8fd;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: border-color 0.2s, background 0.2s;
}

.photo-upload-zone:hover {
  border-color: var(--azul, #3b6fd4);
  background: #f0f4ff;
}

.photo-upload-preview {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  opacity: 0.45;
  transition: opacity 0.2s;
}

.photo-upload-zone:hover .photo-upload-preview {
  opacity: 0.35;
}

.photo-upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #3b6fd4;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  background: rgba(246, 248, 253, 0.45);
}

.photo-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #b0bad4;
}

.photo-upload-placeholder svg {
  color: #b0bad4;
  transition: color 0.2s;
}

.photo-upload-zone:hover .photo-upload-placeholder svg {
  color: var(--azul, #3b6fd4);
}

.photo-upload-placeholder-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #8a96b3;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.photo-upload-placeholder-text small {
  font-size: 10px;
  font-weight: 500;
  color: #b8c0d6;
  text-transform: none;
  letter-spacing: 0.03em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Visitantes/visitantes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;;;;;;EAME,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,sBAAsB;EACtB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;AACxB;;;AAGA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AAmBpB;;AAjBE;IACE,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,eAAe;EAMjB;;AAJE;MACE,gBAAgB;MAChB,gCAAgC;IAClC;;AAIJ;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;;;;;;EAME,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;;EAEE,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":[".visitante-form-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f9f9f9;\n  padding: 20px;\n}\n\n.visitante-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.visitante-logo img {\n  max-width: 200px;\n  object-fit: contain;\n  max-height: 80px;\n  mix-blend-mode: multiply;\n}\n\n.visitante-alert-warning {\n  margin-top: 12px;\n  padding: 12px 16px;\n  background-color: #fff3cd;\n  border: 1px solid #ffe69c;\n  border-left: 4px solid #ffc107;\n  border-radius: 4px;\n  color: #664d03;\n  font-size: 14px;\n  text-align: center;\n  max-width: 600px;\n}\n\n/* Tabs de etapas */\n.visitante-steps {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  max-width: 1000px;\n  margin-bottom: 10px;\n}\n\n.visitante-steps span {\n  font-size: 14px;\n  padding: 10px;\n  font-weight: bold;\n  color: var(--fundo2);\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n}\n\n.visitante-active {\n  color: var(--azul) !important;\n  border-bottom: 2px solid var(--azul) !important;\n}\n\n.visitante-form {\n  background-color: #fff;\n  padding: 40px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 1000px;\n}\n\n.visitante-step {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.visitante-step h2 {\n  font-size: 18px;\n  margin-bottom: 30px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f9f9f9;\n  color: var(--azul);\n\n}\n\n.visitante-step label {\n  font-size: 12px;\n  color: var(--azul);\n\n}\n\n.visitante-step select,\n.visitante-step input[type=\"text\"],\n.visitante-step input[type=\"date\"],\n.visitante-step input[type=\"email\"],\n.visitante-step input[type=\"tel\"],\n.visitante-step input[type=\"file\"] {\n  padding: 8px;\n  font-size: 14px;\n  width: 100%;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  box-sizing: border-box;\n}\n\n.visitante-step input:focus {\n  border-color: var(--azul);\n  outline: none;\n}\n\n/* Estilo dos botões */\n.visitante-buttons {\n  display: flex;\n  justify-content: space-between !important;\n  width: 100%;\n  margin-top: 10px;\n}\n\n\n.visitante-buttons button:disabled {\n  background-color: #ccc;\n  opacity: 0;\n  cursor: default;\n}\n\n.visitante-step p {\n  font-size: 14px;\n  color: #555;\n  line-height: 1.6;\n}\n\n.visitante-step input[type=\"checkbox\"] {\n  margin-right: 10px;\n}\n\n.visitante-error {\n  color: var(--Vermelho);\n  font-size: 11px;\n  margin-bottom: 10px;\n}\n\n.oab-lookup-hint {\n  width: 100%;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--texto);\n  margin: -4px 0 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.oab-lookup-hint-loading {\n  color: var(--texto-destaque);\n  font-weight: 700;\n}\n\n.oab-lookup-spinner {\n  width: 13px;\n  height: 13px;\n  flex-shrink: 0;\n  display: inline-block;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: oab-lookup-spin .7s linear infinite;\n}\n\n@keyframes oab-lookup-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.oab-lookup-box {\n  width: 100%;\n  background-color: var(--fundo2);\n  border: 1px solid var(--texto-destaque);\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin: -4px 0 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.oab-lookup-box strong {\n  color: var(--texto-destaque);\n  font-size: 13px;\n}\n\n.oab-lookup-box span {\n  font-size: 12px;\n  color: var(--texto);\n}\n\n.oab-lookup-box p {\n  margin: 4px 0 0;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--texto-destaque);\n}\n\n.oab-lookup-box.oab-status-regular {\n  background-color: var(--verde2);\n  border-color: var(--verde);\n}\n\n.oab-lookup-box.oab-status-regular strong,\n.oab-lookup-box.oab-status-regular p {\n  color: var(--verde);\n}\n\n.oab-lookup-box.oab-status-cancelado {\n  background-color: var(--vermelho2);\n  border-color: var(--Vermelho);\n}\n\n.oab-lookup-box.oab-status-cancelado strong,\n.oab-lookup-box.oab-status-cancelado p {\n  color: var(--Vermelho);\n}\n\n.oab-lookup-box.oab-status-falecido {\n  background-color: var(--fundo2);\n  border-color: var(--azul);\n}\n\n.oab-lookup-box.oab-status-falecido strong,\n.oab-lookup-box.oab-status-falecido p {\n  color: var(--azul);\n}\n\n.oab-lookup-box.oab-status-outro {\n  background-color: var(--amarelo3);\n  border-color: var(--amarelo2);\n}\n\n.oab-lookup-box.oab-status-outro strong,\n.oab-lookup-box.oab-status-outro p {\n  color: var(--amarelo2);\n}\n\n\n.add-interno-btn {\n\n  max-width: 200px;\n  padding: 6px;\n  margin-bottom: 20px;\n}\n\n.visitante-btn-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.visitante-btn-spinner {\n  width: 14px;\n  height: 14px;\n  display: inline-block;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  opacity: .85;\n  animation: visitante-btn-spin .7s linear infinite;\n}\n\n@keyframes visitante-btn-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.del-interno-btn {\n  padding: 0;\n  background: none;\n  color: var(--Vermelho);\n  text-align: center;\n  font-size: 22px;\n}\n\n.internal-result {\n  position: relative;\n\n  .internal-suggestions {\n    position: absolute;\n    left: 0;\n    top: 50px;\n    max-height: 300px;\n    padding: 8px 0;\n    border-radius: 6px;\n    background-color: #fff;\n    box-shadow: 1px 1px 3px 0;\n    overflow: auto;\n    cursor: pointer;\n\n    >div {\n      padding: 5px 8px;\n      border-bottom: 1px solid #f9f9f9;\n    }\n  }\n}\n\n.internal-result .internal-suggestions>div:hover {\n  background-color: #f9f9f9;\n}\n\n/* Seção de documentos */\n.documents-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n}\n\n/* Campos de input de arquivos para ficarem mais elegantes */\n.visitante-step input[type=\"file\"] {\n  padding: 0;\n  font-size: 14px;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n/* Estilo especial para inputs de arquivo para visualmente indicá-los */\n.visitante-step input[type=\"file\"]::file-selector-button {\n  background-color: var(--azul);\n  color: white;\n  border: none;\n  border-radius: 20px;\n  padding: 10px 16px;\n  cursor: pointer;\n  opacity: .8;\n}\n\n.visitante-step input[type=\"file\"]:hover::file-selector-button {\n  opacity: 1;\n}\n\n.visitante-cadastro-v2 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  background: var(--fundo);\n}\n\n.visitante-cadastro-v2 .visitante-logo {\n  align-self: center;\n  text-align: center;\n}\n\n.visitante-cadastro-v2 .visitante-form-card {\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  background: var(--branco);\n  border-radius: 24px;\n  padding: 32px 36px;\n  border: 1px solid var(--borda);\n  box-shadow: 0 25px 65px rgba(3, 78, 162, 0.08);\n}\n\n.visitante-cadastro-v2 .visitante-mode-switch {\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  display: flex;\n  gap: 10px;\n}\n\n.visitante-cadastro-v2 .visitante-mode-btn {\n  border: 1px solid var(--borda);\n  background: var(--branco);\n  color: var(--texto2);\n  border-radius: 12px;\n  padding: 10px 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.visitante-cadastro-v2 .visitante-mode-btn.active {\n  border-color: var(--azul);\n  color: var(--azul);\n  background: rgba(3, 78, 162, 0.08);\n}\n\n.visitante-cadastro-v2 .visitante-steps {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  background-color: var(--fundo-input);\n  padding: 14px;\n  border-radius: 18px;\n}\n\n.visitante-cadastro-v2 .visitante-steps-item span {\n  padding: 0;\n  color: inherit;\n}\n\n.visitante-cadastro-v2 .visitante-steps-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--texto2);\n  border: 1px solid transparent;\n  transition: all 0.3s ease;\n  min-height: 74px;\n}\n\n.visitante-cadastro-v2 .visitante-steps-index {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: var(--texto-destaque);\n  background: var(--branco);\n  border: 1px solid var(--borda);\n}\n\n.visitante-cadastro-v2 .visitante-steps-item.visitante-active {\n  background: var(--branco);\n  color: var(--azul);\n  border-color: var(--azul);\n  box-shadow: 0 4px 12px rgba(3, 78, 162, 0.1);\n  border-bottom: none;\n}\n\n.visitante-cadastro-v2 .visitante-steps-item.visitante-active .visitante-steps-index {\n  border-color: var(--azul);\n}\n\n.visitante-cadastro-v2 .visitante-steps-item.visitante-complete {\n  background: rgba(0, 121, 50, 0.1);\n  color: var(--verde);\n  border-color: var(--verde);\n}\n\n.visitante-cadastro-v2 .visitante-steps-item.visitante-complete .visitante-steps-index {\n  background: var(--verde);\n  border-color: transparent;\n  color: var(--branco);\n}\n\n.visitante-cadastro-v2 .visitante-steps-label {\n  line-height: 1.2;\n  flex: 1;\n  font-size: 10px;\n  color: inherit;\n  text-align: left;\n  word-break: break-word;\n}\n\n.visitante-cadastro-v2 .visitante-steps-item.visitante-active .visitante-steps-label {\n  color: var(--azul2);\n}\n\n.visitante-cadastro-v2 .visitante-steps-item.visitante-complete .visitante-steps-label {\n  color: var(--verde);\n}\n\n.visitante-cadastro-v2 .visitante-form-modern {\n  margin-top: 28px;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n  width: 100%;\n}\n\n.visitante-cadastro-v2 .visitante-step {\n  background: var(--branco);\n  border: 1px solid var(--borda);\n  border-radius: 18px;\n  padding: 24px;\n  margin-bottom: 18px;\n  box-shadow: 0 12px 30px rgba(17, 16, 29, 0.05);\n}\n\n.visitante-cadastro-v2 .visitante-step h2 {\n  color: var(--texto-destaque);\n  font-size: 20px;\n  margin-bottom: 18px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid transparent;\n  position: relative;\n}\n\n.visitante-cadastro-v2 .visitante-step h2::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 50px;\n  height: 3px;\n  border-radius: 2px;\n  background: var(--amarelo);\n}\n\n.visitante-cadastro-v2 .visitante-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.visitante-cadastro-v2 .visitante-form .form-group-duplo {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n}\n\n.visitante-cadastro-v2 .visitante-step select,\n.visitante-cadastro-v2 .visitante-step input[type=\"text\"],\n.visitante-cadastro-v2 .visitante-step input[type=\"date\"],\n.visitante-cadastro-v2 .visitante-step input[type=\"email\"],\n.visitante-cadastro-v2 .visitante-step input[type=\"tel\"],\n.visitante-cadastro-v2 .visitante-step input[type=\"file\"] {\n  padding: 12px;\n  font-size: 14px;\n  border-radius: 12px;\n  border: 1px solid var(--borda);\n  background: var(--fundo-input);\n  transition: border 0.2s ease, box-shadow 0.2s ease;\n}\n\n.visitante-cadastro-v2 .visitante-step input:focus,\n.visitante-cadastro-v2 .visitante-step select:focus {\n  border-color: var(--azul);\n  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.15);\n  background: var(--branco);\n}\n\n.visitante-cadastro-v2 .add-interno-btn {\n  background: var(--azul);\n  color: var(--branco);\n  border: none;\n  border-radius: 12px;\n  padding: 10px 18px;\n  font-weight: 600;\n}\n\n.visitante-cadastro-v2 .internal-result .internal-suggestions {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 6px);\n  width: 100%;\n  max-height: 220px;\n  background: var(--branco);\n  border: 1px solid var(--borda);\n  border-radius: 12px;\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);\n  overflow: auto;\n  z-index: 2;\n}\n\n.visitante-cadastro-v2 .internal-result .internal-suggestions>div {\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--fundo-input);\n  color: var(--texto);\n}\n\n.visitante-cadastro-v2 .internal-result .internal-suggestions>div:last-child {\n  border-bottom: none;\n}\n\n.visitante-cadastro-v2 .internal-result .internal-suggestions>div:hover {\n  background: var(--fundo-input);\n}\n\n.visitante-cadastro-v2 .visitante-internal-table,\n.visitante-cadastro-v2 .visitante-summary-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 16px;\n  border: 1px solid var(--borda);\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.visitante-cadastro-v2 .visitante-internal-table th,\n.visitante-cadastro-v2 .visitante-summary-table th {\n  background: var(--amarelo3);\n  color: var(--texto-destaque);\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\n.visitante-cadastro-v2 .visitante-internal-table td,\n.visitante-cadastro-v2 .visitante-summary-table td {\n  background: var(--branco);\n  font-size: 14px;\n  border-bottom: 1px solid var(--fundo-input);\n}\n\n.visitante-cadastro-v2 .visitante-summary-table tr:last-child td,\n.visitante-cadastro-v2 .visitante-internal-table tr:last-child td {\n  border-bottom: none;\n}\n\n.visitante-cadastro-v2 .visitante-summary-table td:first-child {\n  color: var(--texto2);\n  font-weight: 600;\n  width: 35%;\n}\n\n.visitante-cadastro-v2 .documents-section {\n  gap: 16px;\n}\n\n.visitante-cadastro-v2 .documents-section .form-group {\n  background: var(--fundo-input);\n  padding: 16px;\n  border-radius: 14px;\n  border: 1px dashed var(--borda);\n}\n\n.visitante-cadastro-v2 .visitante-buttons {\n  padding-top: 6px;\n  justify-content: flex-end !important;\n  gap: 12px;\n}\n\n.visitante-cadastro-v2 .visitante-buttons button {\n  min-width: 150px;\n  height: 44px;\n  border-radius: 14px;\n  font-weight: 600;\n}\n\n.visitante-cadastro-v2 .visitante-btn-secondary {\n  border: 1px solid var(--borda);\n  color: var(--texto-destaque);\n  background: transparent;\n}\n\n.visitante-cadastro-v2 .visitante-btn-secondary:hover {\n  border-color: var(--azul);\n  color: var(--azul);\n}\n\n.visitante-cadastro-v2 .visitante-btn-primary {\n  background: linear-gradient(90deg, var(--azul), var(--azul2));\n  color: var(--branco);\n  border: none;\n}\n\n.visitante-cadastro-v2 .visitante-buttons button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 992px) {\n  .visitante-cadastro-v2 .visitante-form-card {\n    padding: 24px;\n  }\n\n  .visitante-cadastro-v2 .visitante-mode-switch {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 600px) {\n  .visitante-cadastro-v2 .visitante-steps {\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  }\n\n  .visitante-cadastro-v2 .visitante-step {\n    padding: 18px;\n  }\n\n  .visitante-cadastro-v2 .visitante-buttons {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .visitante-cadastro-v2 .visitante-buttons button {\n    width: 100%;\n  }\n\n  .visitante-cadastro-v2 .visitante-mode-btn {\n    width: 100%;\n  }\n}\n\n.visitor-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 120px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.visitor-status.status-verde {\n  color: #00B087;\n  background-color: #CFFAEA;\n}\n\n.visitor-status.status-amarelo {\n  color: #b58900;\n  background-color: #FDF3D5;\n}\n\n.visitor-status.status-vermelho {\n  color: #FFFFFF;\n  background-color: #E24343;\n}\n\n.visitor-status.status-laranja {\n  color: #7A1D0C;\n  background-color: #FFD9D1;\n}\n\n.actions-container {\n  position: relative;\n  display: inline-block;\n}\n\n.btn-actions {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n  color: var(--azul-escuro);\n}\n\n.actions-menu {\n  position: absolute;\n  top: 25px;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n  min-width: 140px;\n  z-index: 10;\n}\n\n.actions-menu .action-item {\n  padding: 10px;\n  border: none;\n  background: none;\n  text-align: left;\n  font-weight: 600;\n  font-size: 12px;\n  color: var(--azul-escuro);\n  cursor: pointer;\n  border-bottom: 1px solid var(--borda);\n}\n\n.actions-menu .action-item:last-child {\n  border-bottom: none;\n}\n\n.actions-menu .action-item:hover {\n  background-color: #f1f1f1;\n}\n\n.visitor-details-page {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.visitor-details-card {\n  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);\n  border: 1px solid #e4e9f6;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 10px 24px rgba(17, 24, 39, 0.06);\n  margin-bottom: 20px;\n  transition: box-shadow .2s ease, border-color .2s ease;\n}\n\n.visitor-details-card:hover {\n  box-shadow: 0 14px 30px rgba(17, 24, 39, 0.09);\n  border-color: #d8e1f7;\n}\n\n.visitor-details-card>header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n  margin-bottom: 16px;\n}\n\n.visitor-details-card>header h3 {\n  margin: 0;\n  color: var(--azul-escuro);\n}\n\n.visitor-details-card>header span {\n  margin: 0;\n  color: var(--texto2);\n  font-size: .8rem;\n}\n\n.visitor-details-card>header p {\n  margin: 4px 0 0;\n  color: var(--texto);\n  font-size: 0.9rem;\n}\n\n.visitor-card-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 16px;\n  color: var(--azul-escuro);\n  font-size: 1.15rem;\n}\n\n.visitor-details-card>header .visitor-card-title {\n  margin: 0;\n}\n\n.visitor-card-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: rgba(3, 78, 162, 0.1);\n  color: var(--azul);\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n\n.visitor-hero-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.visitor-hero-meta h3 {\n  margin: 0;\n  font-size: 1.4rem;\n  color: var(--azul-escuro);\n}\n\n.visitor-hero-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.visitor-hero-photo {\n  width: 92px;\n  height: 114px;\n  border-radius: 12px;\n  border: 1px solid #d5def2;\n  overflow: hidden;\n  background: #f4f7ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.08);\n}\n\n.visitor-hero-photo--clickable {\n  cursor: pointer;\n  transition: opacity 0.15s, border-color 0.15s;\n}\n\n.visitor-hero-photo--clickable:hover {\n  opacity: 0.82;\n  border-color: var(--azul, #3b6fd4);\n}\n\n.visitor-hero-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.visitor-hero-photo span {\n  font-size: 11px;\n  color: #697392;\n  text-align: center;\n  padding: 8px;\n  text-transform: uppercase;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.visitor-hero-photo-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #b0bad4;\n  padding: 8px;\n}\n\n.visitor-hero-photo-empty svg {\n  transition: color 0.2s;\n}\n\n.visitor-hero-photo--clickable:hover .visitor-hero-photo-empty svg {\n  color: var(--azul, #3b6fd4);\n}\n\n.visitor-hero-photo-empty small {\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #b0bad4;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.visitor-hero-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.visitor-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.visitor-info-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.visitor-info-tile {\n  background: #f7f9ff;\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  padding: 12px 14px;\n  min-height: 72px;\n  justify-content: center;\n  transition: border-color .15s ease, background .15s ease;\n}\n\n.visitor-info-tile:hover {\n  border-color: #c7d5f6;\n  background: #f1f5ff;\n}\n\n.visitor-info-row span {\n  font-size: 0.75rem;\n  font-weight: bold;\n  color: var(--texto-destaque);\n  text-transform: uppercase;\n}\n\n.visitor-info-row p {\n  margin: 0;\n  color: var(--texto);\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.visitor-access-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  border: 1px solid transparent;\n}\n\n.visitor-access-tag.enabled {\n  color: #0a7a55;\n  background: #dff8ee;\n  border-color: #b6edd9;\n}\n\n.visitor-access-tag.disabled {\n  color: #7a3b00;\n  background: #fff1de;\n  border-color: #f3d2a6;\n}\n\n.visitor-access-tag.denied {\n  color: #8f1d1d;\n  background: #ffe1e1;\n  border-color: #f4b6b6;\n}\n\n.visitor-access-tag.pending {\n  color: #7a5b00;\n  background: #fff7d8;\n  border-color: #efd98a;\n}\n\n.visitor-details-relations {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.visitor-details-relations > div {\n  background: #f7f9ff;\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.visitor-details-relations strong {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 0.9rem;\n  color: var(--azul-escuro);\n}\n\n.visitor-details-relations ul {\n  list-style: disc;\n  padding-left: 20px;\n  margin: 0;\n  color: var(--texto-destaque);\n}\n\n.visitor-details-relations li {\n  font-size: 0.9rem;\n  margin-bottom: 4px;\n}\n\n.visitor-internal-link {\n  color: var(--azul);\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.visitor-internal-link:hover {\n  color: var(--azul2);\n  text-decoration: underline;\n}\n\n.visitor-docs-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 12px;\n}\n\n.visitor-docs-item {\n  background: #f7f9ff;\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.visitor-docs-item--image {\n  background: #edf3ff;\n  border-color: #cad7f4;\n}\n\n.visitor-docs-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.visitor-docs-meta strong {\n  color: var(--azul-escuro);\n  font-size: 0.95rem;\n}\n\n.visitor-docs-meta span {\n  color: var(--texto);\n  font-size: 0.85rem;\n}\n\n.visitor-docs-empty {\n  color: var(--texto);\n  margin: 0;\n}\n\n.visitor-action-buttons,\n.visitor-section-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.visitor-doc-upload-form .form-group {\n  flex-basis: 100%;\n}\n\n.relationship-results {\n  margin-top: 20px;\n}\n\n.relationship-types-section {\n  margin-top: 12px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--borda);\n}\n\n.relationship-types-section h4 {\n  margin-bottom: 10px;\n  color: var(--texto-destaque);\n}\n\n.relationship-types-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 8px 12px;\n}\n\n.relationship-type-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--texto);\n}\n\n.relationship-type-option input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.relationship-results h4 {\n  margin-bottom: 10px;\n  color: var(--texto-destaque);\n}\n\n.relationship-results table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 10px;\n}\n\n.relationship-results table th,\n.relationship-results table td {\n  border: 1px solid var(--borda);\n  padding: 8px;\n  text-align: left;\n}\n\n.relationship-empty {\n  margin: 10px 0;\n  color: var(--texto);\n}\n\n.relationship-pending-card {\n  margin: 12px 0;\n  padding: 14px 16px;\n  border: 2px solid var(--Azul, #3b82f6);\n  border-radius: 8px;\n  background: var(--fundo-card, #f0f6ff);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.relationship-pending-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.relationship-pending-info strong {\n  font-size: 14px;\n  color: var(--texto-destaque);\n}\n\n.relationship-pending-info span {\n  font-size: 12px;\n  color: var(--texto);\n}\n\n.relationship-pending-form {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.relationship-pending-select {\n  flex: 1;\n  min-width: 160px;\n  padding: 6px 10px;\n  border: 1px solid var(--borda);\n  border-radius: 6px;\n  font-size: 13px;\n  background: var(--fundo);\n  color: var(--texto);\n}\n\n.relationship-pending-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.relationship-type-select {\n  width: 100%;\n  padding: 4px 8px;\n  border: 1px solid var(--borda);\n  border-radius: 4px;\n  font-size: 13px;\n  background: var(--fundo);\n  color: var(--texto);\n}\n\n.auth-modal-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 20px;\n}\n\n.auth-column {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.auth-column h4 {\n  margin: 0;\n  color: var(--texto-destaque);\n}\n\n.auth-status-info {\n  background-color: #eef3ff;\n  border-radius: 6px;\n  padding: 8px;\n  font-size: 0.85rem;\n  color: var(--texto);\n}\n\n.auth-status-tag {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background-color: #f1f1f5;\n  color: var(--texto);\n}\n\n.auth-status-tag.success {\n  background-color: rgba(46, 125, 50, 0.15);\n  color: #2e7d32;\n  font-size: 11px;\n}\n\n.auth-status-tag.danger {\n  background-color: rgba(211, 47, 47, 0.15);\n  color: #d32f2f;\n  font-size: 11px;\n}\n\n.auth-status-tag.pending {\n  background-color: rgba(255, 193, 7, 0.2);\n  color: #b28704;\n}\n\n.auth-textarea-group textarea {\n  max-width: 100%;\n  min-width: 100%;\n  min-height: 90px;\n}\n\n.visitor-authorization-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n}\n\n.authorization-column h4 {\n  margin: 0 0 10px;\n  color: var(--texto-destaque);\n  font-size: 1rem;\n}\n\n.authorization-column {\n  background: #f7f9ff;\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.visitor-auth-history {\n  margin-top: 18px;\n  border-top: 1px solid #e2e8fb;\n  padding-top: 14px;\n}\n\n.visitor-auth-history h4 {\n  margin: 0 0 10px;\n  color: var(--texto-destaque);\n  font-size: 0.95rem;\n}\n\n.visitor-auth-history-list {\n  display: grid;\n  gap: 10px;\n}\n\n.visitor-auth-history-item {\n  background: #f7f9ff;\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.visitor-auth-history-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.visitor-auth-history-head strong {\n  color: var(--azul-escuro);\n  font-size: 0.92rem;\n}\n\n.visitor-auth-history-head span {\n  color: #657390;\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n\n.visitor-auth-history-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 14px;\n}\n\n.visitor-auth-history-grid small {\n  display: block;\n  color: #64748b;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.visitor-auth-history-grid p {\n  margin: 0;\n  color: var(--texto);\n  font-size: 0.9rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n  width: 100%;\n}\n\n.visitor-switch-group {\n  background: #f7f9ff;\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.visitor-switch-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.visitor-switch-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #7a88a8;\n  min-width: 28px;\n  text-align: center;\n}\n\n.visitor-switch-label.active {\n  color: #1f3fa5;\n}\n\n.visitor-switch {\n  position: relative;\n  width: 46px;\n  height: 24px;\n  display: inline-block;\n}\n\n.visitor-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.visitor-switch-slider {\n  position: absolute;\n  inset: 0;\n  background: #cfd8ee;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: .2s ease;\n}\n\n.visitor-switch-slider::before {\n  content: '';\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 3px;\n  top: 3px;\n  border-radius: 50%;\n  background: #fff;\n  transition: .2s ease;\n  box-shadow: 0 1px 3px rgba(0,0,0,.2);\n}\n\n.visitor-switch input:checked + .visitor-switch-slider {\n  background: #2d57cf;\n}\n\n.visitor-switch input:checked + .visitor-switch-slider::before {\n  transform: translateX(22px);\n}\n\n.visitor-autocomplete {\n  position: relative;\n}\n\n.visitor-autocomplete-list {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  max-height: 220px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 6px 0;\n  list-style: none;\n  background: #fff;\n  border: 1px solid #dfe6f5;\n  border-radius: 12px;\n  box-shadow: 0 14px 24px rgba(17, 24, 39, 0.1);\n  z-index: 20;\n}\n\n.visitor-autocomplete-list li {\n  padding: 10px 12px;\n  cursor: pointer;\n  color: var(--texto);\n  font-size: 14px;\n}\n\n.visitor-autocomplete-list li:hover {\n  background: #f5f8ff;\n}\n\n@media (max-width: 768px) {\n  .visitor-details-card > header {\n    flex-direction: column;\n  }\n\n  .visitor-hero-wrapper {\n    width: 100%;\n    align-items: flex-start;\n  }\n\n  .visitor-hero-photo {\n    width: 72px;\n    height: 94px;\n  }\n\n  .visitor-section-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n/* ── Modal de foto do visitante ─────────────────────────────── */\n.photo-modal-header {\n  margin-bottom: 20px;\n}\n\n.photo-modal-label {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1e2a45;\n  letter-spacing: 0.01em;\n}\n\n.photo-modal-hint {\n  font-size: 11px;\n  color: #9aa3bc;\n  margin: 2px 0 0;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.photo-upload-zone {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 220px;\n  border-radius: 14px;\n  border: 2px dashed #cdd6ed;\n  background: #f6f8fd;\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.photo-upload-zone:hover {\n  border-color: var(--azul, #3b6fd4);\n  background: #f0f4ff;\n}\n\n.photo-upload-preview {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  opacity: 0.45;\n  transition: opacity 0.2s;\n}\n\n.photo-upload-zone:hover .photo-upload-preview {\n  opacity: 0.35;\n}\n\n.photo-upload-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: #3b6fd4;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  background: rgba(246, 248, 253, 0.45);\n}\n\n.photo-upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #b0bad4;\n}\n\n.photo-upload-placeholder svg {\n  color: #b0bad4;\n  transition: color 0.2s;\n}\n\n.photo-upload-zone:hover .photo-upload-placeholder svg {\n  color: var(--azul, #3b6fd4);\n}\n\n.photo-upload-placeholder-text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8a96b3;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.photo-upload-placeholder-text small {\n  font-size: 10px;\n  font-weight: 500;\n  color: #b8c0d6;\n  text-transform: none;\n  letter-spacing: 0.03em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
